module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"offMic":"Microphone id disabled","offCamera":"Camera id disabled"}}')
  delete Component.options._Ctor
}
